import { Vue, MsgBox } from '../../app.vues'

import SwbFundTransActRecList from './FundTransActRecList';
Vue.regist(SwbFundTransActRecList);

export function openFundTransActRecDlg(filter, callback) {
    //
    Vue.$showDialog({
        title: '资金往来操作记录 - 查看',
        width: -160,
        height: -160,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-fund-trans-act-rec-list :filter="filter" ref="swb_fund_trans_act_rec_list"></swb-fund-trans-act-rec-list>' +
        '</div>',
        data: {
            filter: filter
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/compo/payment/ActRecDlg.js
// module id = 620
// module chunks = 1